if (!customElements.get('dm-court-guide')) {
  customElements.define('dm-court-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const nav = this.querySelector('[data-court-tabs]');
      const buttons = [...nav.querySelectorAll('button')];
      const panels = [...this.querySelectorAll('[data-court-panel]')];
      if (buttons.length !== panels.length || !panels.length) return;
      const activate = (index, focus = false) => {
        buttons.forEach((button, i) => {
          button.setAttribute('aria-selected', String(i === index));
          button.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) buttons[index].focus();
      };
      nav.setAttribute('role', 'tablist');
      buttons.forEach((button, i) => {
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', panels[i].id);
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', button.id);
        panels[i].tabIndex = 0;
        button.addEventListener('click', () => activate(i));
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(next, true);
        });
      });
      activate(0);
      nav.hidden = false;
      this.querySelector('[data-court-fallback]').hidden = true;
      this.dataset.ready = 'true';
    }
  });
}
